exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.styles_category__1Stzf {\n  align-items: center;\n  color: rgba(255, 255, 255, 0.7);\n  display: flex;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: Archivo;\n  height: 47px;\n  line-height: 14px;\n  margin: 21px 0 0;\n  text-transform: uppercase; }\n\n.styles_line-separator__NWoXU {\n  position: relative; }\n  .styles_line-separator__NWoXU::before {\n    content: ' –– ';\n    margin: 0 5px 2px 40px; }\n\n.styles_group__1UVK6 {\n  display: flex;\n  flex-direction: column-reverse; }\n\n.styles_selected__2-WgE {\n  color: #FFF; }\n", ""]);

// Exports
exports.locals = {
	"category": "styles_category__1Stzf",
	"line-separator": "styles_line-separator__NWoXU",
	"lineSeparator": "styles_line-separator__NWoXU",
	"group": "styles_group__1UVK6",
	"selected": "styles_selected__2-WgE"
};